import React from "react";
import { FOUNDER_IMG } from "../../mock/mock";

const About = () => {
  return (
    <section id="about" className="py-24 md:py-36 bg-[#FFFDF6]">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        {/* Big centered headline */}
        <h2 className="font-serif-display text-[#41232E] text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] leading-[1.02] tracking-[-0.02em] om-fade-up">
          20 years of watching how people turn goals into{" "}
          <em className="italic text-[#605F26]">reality.</em>
        </h2>

        {/* Body copy — narrower column, smaller text, generous line-height */}
        <div className="mt-14 md:mt-16 max-w-2xl mx-auto space-y-6 text-[#41232E]/85 text-base md:text-lg leading-[1.75] om-fade-up">
          <p>
            For more than 20 years, my career has put me in rooms with founders, investors,
            executives and people who had accomplished extraordinary things in very different
            areas of their lives.
          </p>
          <p>
            I wasn&rsquo;t there to study them. I was doing my job. But over time, I started
            noticing patterns in how they set goals, made decisions, approached risk and
            opportunity, and got where they wanted to go.
          </p>
          <p>
            What stood out most was a sense of ownership &mdash; they saw their lives as something
            they could actively shape rather than simply react to.
          </p>
          <p>
            I began applying those lessons to my own life, keeping the ideas, questions and
            frameworks I found genuinely useful.
          </p>
          <p>
            The Owner&rsquo;s Mind is where I share what I&rsquo;ve learned &mdash; so you can use
            what&rsquo;s useful to build more of the life you want.
          </p>
          <p className="pt-2 text-[#41232E]/75">&mdash; Cynthia</p>
        </div>

        {/* Founder photo + handwritten signature */}
        <div className="mt-16 md:mt-20 flex flex-col items-center om-fade-up">
          <div className="overflow-hidden rounded-[1.5rem] w-40 h-40 md:w-48 md:h-48 bg-[#c7bca0] shadow-[0_10px_30px_rgba(65,35,46,0.15)]">
            <img
              src={FOUNDER_IMG}
              alt="Cynthia D"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="font-hand text-[#41232E] text-4xl md:text-5xl mt-5">
            Cynthia D
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
